<template>
    <div class="facturas">

        <div class="dvTitle">
            <h5 class="title">Facturas</h5>
        </div>

        <img src="../../assets/image/comingSon.svg" alt="">
    </div>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex';
    export default {
        name: "Factura",

        mounted: function () {
            window.addEventListener("resize", this.resize);
            setTimeout(() => {
                this.resize();
            }, 300);
        },

        methods: {

            ...mapMutations([
                'SET_MENU',
            ]),

            resize: function () {
                if (window.innerWidth <= 992) {
                    this.SET_MENU(false);
                }
            }
        }

    }
</script>

<style scoped lang="scss">
    @import "../../style/base";

    .facturas {
        padding: 30px;
        border: 1px solid #e6ebf4;
        border-radius: .25rem;
        background-color: #fff;
        margin: 20px;

        animation-name: fade;
        animation-duration: 1.5s;
        animation-timing-function: ease-in-out;

        & .dvTitle {
            @include flexRow;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 20px;
        }

        img {
            width: 100%;
        }
    }

</style>